import * as yup from 'yup'

const schema = yup.object().shape({
  fileType: yup.string().required('Escolha uma opção'),
})

export default schema
